import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
import ApiService from 'services/ApiService';
import { repeatEffect, settingsConfig } from 'utils/commonFunc';
import module from 'pages/css/moduleStyle.module.css';
import styles from 'pages/css/trfSfty.module.css';

const TrafficTotalContext = createContext(null);

export function SwItsGetRoadStatTotalProvider({ children }) {
  const [currentData, setCurrentData] = useState();

  useEffect(() => {
    return repeatEffect(async () => {
      const response = await ApiService.get("newdashboard/trfsfty/GetRoadStat");
      if (response.status === 200) {
        const data = response.data;

        setCurrentData({
          updateTime: data.updateTime,
          roadStatValue: data.total,
          roadStatTotal: data.rows
        });
      }
    }, settingsConfig().contentUpdateDelaySec);
  }, []);

  return (
    <TrafficTotalContext.Provider value={currentData}>
      {children}
    </TrafficTotalContext.Provider>
  );
}

// 노면검지 사운드파일 추가
// export function SwItsGetRoadStatInfo({ hideSoundBtn = false }) {
//   const currentData = useContext(TrafficTotalContext);
//   if (!currentData) return null;

//   const playSound = (label, type = 'original') => {
//     const cleanLabel = label.toLowerCase();
//     const suffix = type === 'original' ? '' : '_filter';
//     const soundSrc = `/sounds/${cleanLabel}${suffix}.wav`;

//     const audio = new Audio(soundSrc);
//     audio.play().catch(err => console.error('Sound play error:', err));
//   };

//   const renderBox = (label, value, colorVar) => (
//     <div className={`${styles.fgrBox_trfSfty} fgrBox innerBg flx flx_col j_center a_center`}>
//       <div className='flx a_center gap10'>
//         <p>{label}</p>
//         {!hideSoundBtn && label !== '장애' && (
//           <button
//             type="button"
//             className={`${module.soundBtn1_trfSfty} soundBtn`}
//             onClick={() => playSound(label, 'original')}
//           />
//         )}
//         {!hideSoundBtn && label !== '장애' && (
//           <button
//             type="button"
//             className={`${module.soundBtn2_trfSfty} soundBtn`}
//             onClick={() => playSound(label, 'original')}
//           />
//         )}
//       </div>
//       <div className='flx a_center gap14'>
//         <p className="fgr" style={{ color: `var(${colorVar})` }}>{value}</p>
//       </div>
//     </div>
//   );

//   return (
//     <div className={`${styles.fgrWrap_trfSfty} fgrWrap flx a_center j_spc_btw`}>
//       {renderBox('DRY', currentData.roadStatValue.dry, '--white')}
//       {renderBox('WET', currentData.roadStatValue.wet, '--caution')}
//       {renderBox('ICE', currentData.roadStatValue.ice, '--alert-50')}
//       {renderBox('장애', currentData.roadStatValue.err, '--white-50')}
//     </div>
//   );

// };

// export function SwItsGetRoadStatInfo({ hideSoundBtn = false }) {
//   const currentData = useContext(TrafficTotalContext);
//   const audioRef = useRef(null);
//   const [playingLabel, setPlayingLabel] = useState(null);

//   if (!currentData) return null;

//   const playSound = (label, type = 'original') => {
//     stopSound(); // 기존 재생 중지

//     const cleanLabel = label.toLowerCase();
//     const suffix = type === 'original' ? '' : '_filter';
//     const soundSrc = `/sounds/${cleanLabel}${suffix}.wav`;
//     const audio = new Audio(soundSrc);
//     audioRef.current = audio;

//     audio.play()
//       .then(() => setPlayingLabel(label))
//       .catch(err => {
//         console.error('Sound play error:', err);
//         setPlayingLabel(null);
//       });

//     audio.onended = () => setPlayingLabel(null);
//   };

//   const stopSound = () => {
//     if (audioRef.current) {
//       audioRef.current.pause();
//       audioRef.current.currentTime = 0;
//       audioRef.current = null;
//       setPlayingLabel(null);
//     }
//   };

//   const renderBox = (label, value, colorVar, index) => {
//     const isPlaying = playingLabel === label;
//     const extraClass = `fgrBox${index + 1}`;

//     return (
//       <div className={`${styles.fgrBox_trfSfty} fgrBox ${extraClass} innerBg flx flx_col j_center a_center`}>
//         <div className='flx a_center gap10'>
//           <p>{label}</p>
//           {!hideSoundBtn && label !== '장애' && (
//             // <button
//             //   type="button"
//             //   className={`${module.soundBtn1_trfSfty} soundBtn ${isPlaying ? 'playing' : ''}`}
//             //   onClick={() => playSound(label, 'original')}
//             // />
//             <button
//               type="button"
//               className={`${isPlaying ? module.soundBtn3_trfSfty : module.soundBtn1_trfSfty
//                 } soundBtn`}
//               onClick={() => playSound(label, 'original')}
//             />
//           )}
//           {!hideSoundBtn && label !== '장애' && (
//             <button
//               type="button"
//               className={`${module.soundBtn2_trfSfty} soundBtn`}
//               onClick={stopSound}
//             />
//           )}
//         </div>
//         <div className='flx a_center gap14'>
//           <p className="fgr" style={{ color: `var(${colorVar})` }}>{value}</p>
//         </div>
//         <div className='spkActiveBox'>
//           <div className='imgBox'></div>
//         </div>
//       </div>
      
//     );
//   };

//   return (
//     <div className={`${styles.fgrWrap_trfSfty} fgrWrap flx a_center j_spc_btw`}>
//       {renderBox('DRY', currentData.roadStatValue.dry, '--white', 0)}
//       {renderBox('WET', currentData.roadStatValue.wet, '--caution', 1)}
//       {renderBox('ICE', currentData.roadStatValue.ice, '--iv-08', 2)}
//       {renderBox('장애', currentData.roadStatValue.err, '--white-50', 3)}
//     </div>
//   );
// }


export function SwItsGetRoadStatInfo({ hideSoundBtn = false }) {
 const currentData = useContext(TrafficTotalContext);
 const audioRef = useRef(null);
 const [playingLabel, setPlayingLabel] = useState(null);

 if (!currentData) return null;

 const playSound = (label, type = 'original') => {
   stopSound(); // 기존 재생 중지

   const cleanLabel = label.toLowerCase();
   const suffix = type === 'original' ? '' : '_filter';
   const soundSrc = `/sounds/${cleanLabel}${suffix}.wav`;
   const audio = new Audio(soundSrc);
   audioRef.current = audio;

   audio.play()
     .then(() => setPlayingLabel(label))
     .catch(err => {
       console.error('Sound play error:', err);
       setPlayingLabel(null);
     });

   audio.onended = () => setPlayingLabel(null);
 };

 const stopSound = () => {
   if (audioRef.current) {
     audioRef.current.pause();
     audioRef.current.currentTime = 0;
     audioRef.current = null;
     setPlayingLabel(null);
   }
 };

 const renderBox = (label, value, colorVar, index) => {
   const isPlaying = playingLabel === label;
   const extraClass = `fgrBox${index + 1}`;

   return (
     <div className={`${styles.fgrBox_trfSfty} fgrBox ${extraClass} innerBg flx flx_col j_center a_center`}>
       <div className='flx a_center gap10'>
         <p>{label}</p>
         {!hideSoundBtn && label !== '장애' && (
           <button
             type="button"
             className={`${isPlaying ? module.soundBtn3_trfSfty : module.soundBtn1_trfSfty} soundBtn`}
             onClick={() => playSound(label, 'original')}
           />
         )}
         {!hideSoundBtn && label !== '장애' && (
           <button
             type="button"
             className={`${module.soundBtn2_trfSfty} soundBtn`}
             onClick={stopSound}
           />
         )}
       </div>
       <div className='flx a_center gap14'>
         <p className="fgr" style={{ color: `var(${colorVar})` }}>{value}</p>
       </div>
       <div 
         className='spkActiveBox'
         style={{ display: isPlaying ? 'block' : 'none' }}
       >
       </div>
     </div>
   );
 };

 return (
   <div className={`${styles.fgrWrap_trfSfty} fgrWrap flx a_center j_spc_btw`}>
     {renderBox('DRY', currentData.roadStatValue.dry, '--white', 0)}
     {renderBox('WET', currentData.roadStatValue.wet, '--caution', 1)}
     {renderBox('ICE', currentData.roadStatValue.ice, '--iv-08', 2)}
     {renderBox('장애', currentData.roadStatValue.err, '--white-50', 3)}
   </div>
 );
}


export function SwItsGetRoadStatLine() {
  const currentData = useContext(TrafficTotalContext);
  const [activeIndex, setActiveIndex] = useState(null);
  const containerRefs = useRef([]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        containerRefs.current.every(ref => ref && !ref.contains(e.target))
      ) {
        setActiveIndex(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if (!currentData) return null;

  const statusMap = {
    '001': { label: 'DRY', color: '', style: {} },
    '003': { label: 'WET', color: 'var(--caution)', style: { color: 'var(--caution)', background: 'var(--caution)' } },
    '006': { label: 'ICE', color: 'var(--iv-08)', style: { color: 'var(--iv-08)', background: 'var(--iv-08)' } },
    '009': { label: 'ERR', color: 'var(--white-50)', style: { color: 'var(--white-50)', background: 'var(--white-50)' } },
  };

  return (
    <div className={`${styles.chart_trfSfty} chart`}>
      <div className="line"></div>
      <div className={`${styles.chartConts_trfSfty} chartConts flx a_center j_spc_btw`}>
        {currentData.roadStatTotal.map((item, idx) => {
          const stat = statusMap[item.statCd] || { label: 'UNKNOWN', style: {} };
          return (
            <div
              key={idx}
              ref={el => (containerRefs.current[idx] = el)}
              className="flx flx_col a_center j_center"
              style={{ position: 'relative' }}
            >
              <span className="titBtn" style={{ color: stat.style.color || '' }}>{stat.label}</span>
              <div className="circle" style={{ background: stat.style.background || '' }}></div>
              <p className="insctNm">{item.rodeNickNm}</p>
              <button type="button" onClick={() => setActiveIndex(activeIndex === idx ? null : idx)}></button>

              {activeIndex === idx && (
                <div className={`${styles.photoArea_trfSfty}`}>
                  <img
                    src={item.snshtPath || "/images/facility/surf_thumbnail.jpg"}
                    alt="노면 이미지"
                    title={item.snshtPath || "/images/facility/surf_thumbnail.jpg"}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 'inherit' }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
